import { lazy } from 'react'

/**
 * `React.lazy` with a one-shot retry. A rejected dynamic import (a CDN blip, or a
 * stale chunk hash right after a deploy) is retried once before the rejection
 * propagates to the nearest error boundary. React 18 caches a rejected lazy
 * factory, so an error-boundary reset alone re-throws — the in-factory retry is
 * the only recovery for a transient in-flight flake; a persistent failure still
 * lands in the boundary.
 *
 * Typed as `typeof lazy` so call sites infer exactly as the bare `lazy` calls
 * they replace — a hand-rolled generic bound can't satisfy `FC`'s covariant
 * `propTypes` member without an explicit `any`.
 */
const lazyWithRetry: typeof lazy = (factory) => lazy(() => factory().catch(() => factory()))

export default lazyWithRetry
